package com.gsb.vyapar.bhagya.presentation.auth.view

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.captureImage
import com.gsb.vyapar.bhagya.domain.*
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.interactor.util.hideLoading
import com.gsb.vyapar.bhagya.interactor.util.resizeImage
import com.gsb.vyapar.bhagya.interactor.util.rotateLeft
import com.gsb.vyapar.bhagya.interactor.util.rotateRight
import com.gsb.vyapar.bhagya.interactor.util.showLoading
import com.gsb.vyapar.bhagya.interactor.util.uploadImage
import com.gsb.vyapar.bhagya.presentation.auth.util.chooseImage
import com.gsb.vyapar.bhagya.presentation.auth.util.saveUserUI
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButtonESmall
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButtonSmall
import com.gsb.vyapar.bhagya.presentation.common.edittext.*
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.PlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.ZoomableImage
import com.gsb.vyapar.bhagya.presentation.common.image.SmoothImageRound
import com.gsb.vyapar.bhagya.presentation.common.platformImePadding
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.theme.close
import com.gsb.vyapar.bhagya.theme.primary
import com.gsb.vyapar.bhagya.theme.rotateleft
import com.gsb.vyapar.bhagya.theme.rotateright
import com.gsb.vyapar.bhagya.toComposeImageBitmap
import com.gsb.vyapar.bhagya.util.BLANK_PROFILE
import com.gsb.vyapar.bhagya.util.getPrivacyUrl
import com.gsb.vyapar.bhagya.util.getTermsUrl
import com.gsb.vyapar.bhagya.util.orEmpty
import com.gsb.vyapar.bhagya.util.value
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerType
import kotlinx.coroutines.launch

@Composable
fun RegisterView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val uriHandler = LocalUriHandler.current
    var mobile by remember { mutableStateOf("") }
    var email by remember { mutableStateOf("") }
    var image by remember { mutableStateOf("") }
    var firstName by remember { mutableStateOf("") }
    var lastName by remember { mutableStateOf("") }
    var gotra by remember { mutableStateOf("") }
    var kuldev by remember { mutableStateOf("") }
    var userId by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var isRegister by remember { mutableStateOf(firstName.isEmpty()) }
    var imageFile: Pair<ByteArray, String>? by remember { mutableStateOf(null) }
    val coroutineScope = rememberCoroutineScope()
    val imagePickerLauncher = rememberFilePickerLauncher(PickerType.Image) { selectedImage ->
        if (selectedImage != null) {
            launchDefault {
                imageFile = Pair(resizeImage(selectedImage.readBytes().orEmpty()), selectedImage.name)
                hideLoading()
            }
        } else {
            hideLoading()
        }
    }
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            Toolbar(if (isRegister) "Register" else "Edit Profile")
            Column(
                modifier = Modifier.verticalScroll(rememberScrollState()).fillMaxWidth().padding(16.dp).platformImePadding(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Spacer(Modifier.height(15.dp))
                SmoothImageRound(
                    uiState.getImage(image.ifEmpty { BLANK_PROFILE.value() }),
                    width = 150.dp,
                    height = 150.dp,
                    modifier = Modifier.clickable {
                        chooseImage({
                            showLoading()
                            coroutineScope.launch {
                                val selectedImage = captureImage()
                                if (selectedImage != null) {
                                    launchDefault {
                                        imageFile = Pair(resizeImage(selectedImage), "File")
                                        hideLoading()
                                    }
                                } else {
                                    hideLoading()
                                }
                            }
                        }, {
                            imagePickerLauncher.launch()
                            showLoading()
                        })
                    }
                )
                Spacer(Modifier.height(15.dp))
                FirstNameEditText(firstName) { firstName = it }
                Spacer(Modifier.height(8.dp))
                LastNameEditText(lastName) { lastName = it }
                Spacer(Modifier.height(8.dp))
                MobileNumberEditText(mobile, false) {  }
                Spacer(Modifier.height(8.dp))
                EmailEditText(email, false) {  }
                Spacer(Modifier.height(8.dp))
                GotraEditText(gotra) { gotra = it }
                Spacer(Modifier.height(8.dp))
                KuldevEditText(kuldev) { kuldev = it }
                Spacer(Modifier.height(8.dp))
                UserIdEditText(userId) {  }
                Spacer(Modifier.height(8.dp))
                UserIdPasswordEditText(password) { password = it }
                Spacer(Modifier.height(16.dp))
                GVBButton(text = if (isRegister) "Register" else "Save") {
                    saveUserUI(mobile, email, image, firstName, lastName, gotra, kuldev, password)
                }
                Spacer(Modifier.weight(1f))
                Row(modifier = Modifier.fillMaxWidth().padding(top = 16.dp), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text14RegularB("Privacy Policy", primary, Modifier.clickable { uriHandler.openUri(getPrivacyUrl()) })
                    Text14RegularB("Terms & Conditions", primary, Modifier.clickable { uriHandler.openUri(getTermsUrl()) })
                }
            }
        }
        imageFile?.let {
            Surface(
                modifier = Modifier.fillMaxSize(),
                color = MaterialTheme.colors.background
            ) {
                Box(
                    modifier = Modifier.fillMaxSize().background(Color.Black).padding(16.dp)
                ) {
                    Column(modifier = Modifier.padding(55.dp).fillMaxSize().pointerInput(Unit) {}) {
                        ZoomableImage(it.first.toComposeImageBitmap())
                    }
                    Row(modifier = Modifier.align(Alignment.BottomCenter).padding(16.dp)) {
                        CommonImage(rotateleft, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile = Pair(rotateLeft(imageFile!!.first), imageFile!!.second)
                            }
                        })
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Cancel") {
                            imageFile = null
                        }
                        Spacer(Modifier.width(8.dp))
                        GVBButtonESmall(text = "Upload") {
                            val imageData = it.first
                            val fileNmae = it.second
                            imageFile = null
                            showLoading()
                            uploadImage(imageData, fileNmae) {
                                image = it
                                hideLoading()
                            }
                        }
                        Spacer(Modifier.width(8.dp))
                        CommonImage(rotateright, 50.dp, 50.dp, Modifier.clickable {
                            launchDefault {
                                imageFile = Pair(rotateRight(imageFile!!.first), imageFile!!.second)
                            }
                        })
                    }
                    CommonImage(close, 30.dp, 30.dp, Modifier.align(Alignment.TopEnd).clickable { imageFile = null })
                }
            }
        }
    }
    LaunchedEffect(Unit) {
        val user = uiState.getUser()
        mobile = user.getMobile()
        email = user.getEmail()
        image = user.getImage()
        firstName = user.getFirstName()
        lastName = user.getLastName()
        gotra = user.getGotra()
        kuldev = user.getKuldev()
        userId = user.getId()
        password = user.getPassword()
        isRegister = firstName.isEmpty()
    }
}